<template>
  <div>
    <v-row
      justify="center">
      <v-card
        width="500px">
        <v-card-title>
          Reset Password
        </v-card-title>
        <v-card-text>
          <v-form
            ref="form"
            v-model='valid'>
            <v-text-field
              outline
              required
              v-model='newPassword'
              :rules='passwordRules'
              @click:append="showPassword = !showPassword"
              label="Please enter a new password."
              :type="showPassword ? 'text' : 'password'"
              @keyup.enter.prevent="resetPassword"
              :append-icon="showPassword ? 'visibility' : 'visibility_off'"></v-text-field>
            <v-text-field
              outline
              required
              :rules='verifyRules'
              :type="showPassword ? 'text' : 'password'"
              label="Please verify your new password."
              @keyup.enter.prevent="resetPassword"></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            :disabled="!valid"
            @click="resetPassword">Reset Password</v-btn>
        </v-card-actions>
      </v-card>
    </v-row>

    <v-dialog v-model="resetError" max-width="500px">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          There was a problem reseting your password click continue to go back to the login page. On the login page try having a new reset email sent to you.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="reroute()">
            continue
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="resetSuccess" max-width="500px">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          Your password has been changed successfully! Click continue to be routed to the login page.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="reroute()">
            continue
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import router from "../router"

  export default {
    data () {
      return {
        valid: false,
        resetError: false,
        resetSuccess: false,
        showPassword: false,
        newPassword: '',
        newPassVerify: '',
        passwordRules: [
          v => /[a-z]+/.test(v) || 'One lowercase letter required.',
          v => /[A-Z]+/.test(v) || 'One uppercase letter required.',
          v => /.{8,}/.test(v) || '8 characters minimum.',
          v => /[0-9]+/.test(v) || 'One number required.'
        ],
        verifyRules: [
          v => v === this.newPassword || 'Passwords must match'
        ],
      }
    },
    mounted() {
      console.log(this.$route.query.oobCode);
    },
    methods: {
      resetPassword() {
        const url = 'https://identitytoolkit.googleapis.com/v1/accounts:resetPassword?key=' + process.env.VUE_APP_ROOT_API_KEY;
        const options = {
          "oobCode": this.$route.query.oobCode,
          "newPassword": this.newPassword
        };
        this.$axios
          .post(url, options)
          .then(res => {
            this.resetSuccess = true;
          })
          .catch(error => {
            this.resetError = true;
          });
      },
      reroute() {
        router.push('/login')
      }
    },
  }
</script>

<style>
</style>
